import React from "react";
import { Spinner } from "react-rainbow-components";
import ListCustomer from "../../components/chatComponent/ListCustomer";
import HeaderComponent from "../../components/common/HeaderSectionComponent";
import { NullCase, Container } from "./index.style";
import useListBookingPage from "./useListBookingPage";
export default function ChatPage() {
  const { isLoading, bookings } = useListBookingPage();
  return (
    <Container>
      <HeaderComponent
        title="Chat"
        subheader="สนทนาให้คำปรึกษาลูกค้าที่คุณเลือก"
      />
      {isLoading ? (
        <Spinner />
      ) : bookings.length === 0 ? (
        <NullCase>ไม่มีเคสที่กำลังดูแล</NullCase>
      ) : (
        <ListCustomer listBookings={bookings} />
      )}
    </Container>
  );
}
